import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { APP_PAGES, ROUTE_PARAM_ID } from '../routes/constants';
import { useDoBoxDropdownStore, usePendingActionsStore } from '../store';

const DOBOX_PREVIEW_RESET_DELAY_MS = 100;

export function useDoBoxNavigationListener(): void {
  const location = useLocation();
  const { setFromDoBoxPreview, resetDropdownStates } = useDoBoxDropdownStore();
  const hasPendingActions = usePendingActionsStore(
    (state) => state.pendingActions.size > 0,
  );

  useEffect(() => {
    if (!hasPendingActions) {
      return;
    }
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasPendingActions]);

  useEffect(() => {
    const currentPath = location.pathname;
    const isDoBoxPage = currentPath === APP_PAGES.DOBOX;
    const isDoBoxPreviewPage = currentPath.includes(
      APP_PAGES.DOBOX_PREVIEW.replace(ROUTE_PARAM_ID, ''),
    );

    if (!isDoBoxPage && !isDoBoxPreviewPage) {
      setFromDoBoxPreview(false);
      resetDropdownStates();
    }

    if (isDoBoxPage) {
      const timeoutId = setTimeout(() => {
        setFromDoBoxPreview(false);
      }, DOBOX_PREVIEW_RESET_DELAY_MS);

      return () => clearTimeout(timeoutId);
    }
  }, [location.pathname, setFromDoBoxPreview, resetDropdownStates]);
}
